import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H3Props = Omit<HeadingProps, 'tagName'>;

const H3 = styled(Heading).attrs({
  tagName: 'h3',
})``;

H3.displayName = 'H3';

export default H3;
